function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useMemo, useState } from 'react';
import { ENVS, getEnv, getRegion } from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
import { noop } from '@adsk/alloy-react-helpers';
import { useOxygenId } from './hooks/useOxygenId';
import createLaunchDarklyContext, { DEFAULT_ANONYMOUS_USER_ID } from './LaunchDarklyContext';
const LD_API_KEYS = {
  [ENVS.QA]: '5e4c38359d07d807cfb6fc26',
  [ENVS.STAGING]: '5e4c3835aadaaf0815842d0e',
  [ENVS.PRODUCTION]: '5e4c3834d497f707dd287f20'
};
export const AlloyLaunchDarklyContext = getOrCreateGlobalContext(CONTEXT_NAMES.AlloyLaunchDarklyContext);
const {
  SimpleLaunchDarklyProvider,
  useFeatureFlag: useAlloyFeatureFlag,
  useAllFeatureFlags: useAlloyAllFeatureFlags
} = createLaunchDarklyContext(AlloyLaunchDarklyContext);
const AlloyLaunchDarklyUserContext = /*#__PURE__*/createContext({
  setUser: noop,
  setProjectId: noop,
  setAccountId: noop,
  user: undefined
});
const useAlloyLaunchDarklyUser = (user, region, accountId, projectId) => {
  const {
    analyticsId,
    email
  } = user || {};
  const {
    oxygenId
  } = useOxygenId();
  return useMemo(() => {
    const custom = {
      region
    };
    if (accountId) {
      Object.assign(custom, {
        accountId
      });
    }
    if (projectId) {
      Object.assign(custom, {
        projectId
      });
    }
    if (oxygenId) {
      Object.assign(custom, {
        oxygenId
      });
    }
    return _objectSpread({
      kind: 'user',
      key: analyticsId || DEFAULT_ANONYMOUS_USER_ID,
      anonymous: true,
      email
    }, custom);
  }, [oxygenId, email, analyticsId, region, accountId, projectId]);
};
const useAlloyLaunchDarklyMetaData = () => {
  return useContext(AlloyLaunchDarklyUserContext);
};
const AlloyLaunchDarklyProvider = props => {
  const env = getEnv();
  const apiKey = useMemo(() => LD_API_KEYS[env], [env]);
  const region = getRegion();
  const [user, setUser] = useState(undefined);
  const [accountId, setAccountId] = useState(undefined);
  const [projectId, setProjectId] = useState(undefined);
  const ldUser = useAlloyLaunchDarklyUser(user, region, accountId, projectId);
  const options = useMemo(() => ({
    allAttributesPrivate: true,
    sendEventsOnlyForVariation: true
  }), []);
  return /*#__PURE__*/React.createElement(AlloyLaunchDarklyUserContext.Provider, {
    value: {
      projectId,
      accountId,
      user,
      setUser,
      setProjectId,
      setAccountId
    }
  }, /*#__PURE__*/React.createElement(SimpleLaunchDarklyProvider, _extends({
    user: ldUser,
    apiKey: apiKey,
    options: options
  }, props)));
};
export { useAlloyFeatureFlag, useAlloyAllFeatureFlags, useAlloyLaunchDarklyMetaData, AlloyLaunchDarklyProvider };
//# sourceMappingURL=AlloyLaunchDarklyProvider.js.map